import { css } from '@emotion/react';
import { Gray, White } from '@constants/color';

export const content = css({
  overflow: 'hidden',
  display: 'flex'
});

export const title = css({
  fontWeight: 700,
  fontSize: 48,
  lineHeight: '62.4px',
  color: White.White10,
  padding: '80px 0'
});

export const scrollButtonContainer = css({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  alignItems: 'center',
  rowGap: '24px',
  minWidth: 216
});

export const agreementContents = css({
  overflowY: 'scroll',
  whiteSpace: 'break-spaces',
  fontWeight: 700,
  fontSize: 20,
  lineHeight: '180%',
  color: Gray.Gray60,
  height: 690,
  width: 1000
});

export const agreementContent = css({
  paddingBottom: 80
});

export const agreementContentContainer = css({
  display: 'flex',
  flexDirection: 'column'
});

export const subTitle = css({
  fontWeight: 700,
  fontSize: 24,
  lineHeight: '130%',
  color: White.White10
});
